// src/pages/Withdraw/WithdrawMethod.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Withdraw.css';

const WithdrawMethod = () => {
  const navigate = useNavigate();

  return (
    <div className="withdraw-page">
      <div className="withdraw-header">
        <button className="back-link" onClick={() => navigate('/dashboard')}>
          <span className="back-arrow">←</span> Back to Dashboard
        </button>
      </div>

      <div className="withdraw-method-page">
        <h1 className="method-page-title">Choose Withdrawal Method</h1>

        <div className="method-cards">
          <div className="method-card" onClick={() => navigate('/withdraw/bank')}>
            <div className="method-card-icon">🏦</div>
            <div className="method-card-content">
              <h3 className="method-card-title">Bank Transfer</h3>
              <p className="method-card-description">Withdraw to your Nigerian bank account</p>
            </div>
          </div>

          <div className="method-card" onClick={() => navigate('/withdraw/crypto')}>
            <div className="method-card-icon">₿</div>
            <div className="method-card-content">
              <h3 className="method-card-title">Cryptocurrency</h3>
              <p className="method-card-description">Withdraw via blockchain networks</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WithdrawMethod;